import {
  defaultFilterState,
  InclusiveExclusive,
  PotentialBookingStatuses,
  usePotentialBookingFiltersContext,
} from '@sales-app/context/potentialBookingFilters/potentialBookingFilters'
import { AgentDashboardStats, HotMarkets } from '@sales-app/types/AgentDashboard'
import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'

import { Card } from '@/views/Dashboard/Card'

type AgentDashboardStatsProps = {
  statData: AgentDashboardStats | undefined
}

export const DashboardStats: FC<AgentDashboardStatsProps> = ({ statData }) => {
  const { setFilters } = usePotentialBookingFiltersContext()
  const navigate = useNavigate()

  const handleUnassignedBookings = () => {
    setFilters({ ...defaultFilterState, unassigned: true })
    navigate('/potential-booking')
  }

  const handleNotContactedBookings = () => {
    setFilters({
      ...defaultFilterState,
      potentialBookingStatuses: {
        inclusive: InclusiveExclusive.INCLUSIVE,
        descriptions: [PotentialBookingStatuses.NEW],
      },
    })
    navigate('/potential-booking')
  }

  const handleUpcomingBookings = () => {
    setFilters({
      ...defaultFilterState,
      potentialBookingStatuses: {
        inclusive: InclusiveExclusive.EXCLUSIVE,
        descriptions: [PotentialBookingStatuses.APPROVED, PotentialBookingStatuses.BOOKED],
      },
      moveInWithin: 14,
    })
    navigate('/potential-booking')
  }

  const getHotMarkets = (hotMarkets: HotMarkets[] | undefined) => {
    if (!hotMarkets) return 'N/A'
    return hotMarkets.map((market) => market.displayCity.name).join(', ')
  }

  return (
    <>
      <div className="grid grid-cols-6 grid-rows-1 place-items-stretch gap-3  md:gap-4">
        <div className="col-span-3">
          <Card
            label="Potential Bookings Queue"
            onClick={() => handleUnassignedBookings()}
            value={statData?.unassignedPotentialBookings}
          />
        </div>
        <div className="col-span-3">
          <Card label="Hot Markets" stringValue={getHotMarkets(statData?.hotMarkets)} />
        </div>
        <div className="col-span-2">
          <Card
            label="Potential Bookings Not Contacted"
            onClick={() => handleNotContactedBookings()}
            value={statData?.potentialBookingsNotContacted}
          />
        </div>
        <div className="col-span-2">
          <Card
            label="Potential Bookings With Upcoming Move-Ins"
            onClick={() => handleUpcomingBookings()}
            subLabel="Next 14 Days"
            value={statData?.potentialBookingsWithUpcomingMoveIns}
          />
        </div>
        <div className="col-span-2">
          <Card
            label="Conversion Rate"
            percentage={true}
            subLabel="Last 2 Weeks"
            value={statData?.agentConversionRate}
          />
        </div>
      </div>
    </>
  )
}
